import styled from 'styled-components';
import { device } from '../../styles/devices';
import { COLORS } from '../../styles/variables';
import type { ThemeProps } from '../../types';
import { SYS_SIZE_FIXED_200, SYS_SIZE_FIXED_400 } from '@oneaudi/unified-web-common';

interface StyleProps {
  active: boolean;
}

export const TabsContainer = styled.div`
  // delete default underline of active tab
  position: relative;
  width: 100%;
  padding: 0px;
  margin: 0px;
  min-height: 680px;

  @media ${device.tablet} {
    min-height: 460px;
  }
  div[role='tabpanel'] {
    background-color: ${(props: { theme: ThemeProps }) =>
      props.theme.sys.color.surface.neutral[600]};
    padding: 0;
  }
  li {
    &:focus {
      // outline for other browsers
      outline: 2px solid #4c8bf5;
      outline: 5px auto -webkit-focus-ring-color;
    }
    @media ${device.tablet} {
      &:hover {
        background: ${(props: { theme: ThemeProps }) => props.theme.sys.color.surface.neutral[600]};
      }
    }
  }
  button {
    // change styles of active tab
    &[aria-selected='true'] {
      font-weight: 700;
      color: ${(props: { theme: ThemeProps }) => props.theme.sys.color.surface.neutral[100]};
      div {
        margin: 0px ${SYS_SIZE_FIXED_200}px;
      }
    }
    div {
      margin: 0 ${SYS_SIZE_FIXED_400}px !important;
    }
  }
`;

export const ContentContainer = styled.ul`
  position: relative;
  width: 100%;
  padding: 0;
  margin: 0;
  min-height: 680px;
  @media ${device.tablet} {
    min-height: 460px;
  }
`;

export const Content = styled.li`
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: ${COLORS.audiGrayFive};
  display: none;
  padding: 0;
  overflow-y: scroll;
  display: ${({ active }: StyleProps) => active && 'block'}}
  @media ${device.tablet} {
    overflow: hidden;
  }
`;

export const ContentWrapper = styled.div`
  @media ${device.tablet} {
    overflow: hidden;
  }
`;
